// extracted by mini-css-extract-plugin
export default {"billHeader":"styles_billHeader__eQXiw","billInfo":"styles_billInfo__p-b-2","back":"styles_back__eVd33","billActions":"styles_billActions__DaoCO"};